import React from 'react';
import styled from 'styled-components';
import logo from '../../../assets/imgs/logo-green.svg';

const Image = props => {
  const { className, children } = props;
  return (
    <div className={className}>
      <Logo src={logo} alt='Tjeders' />
      {children}
    </div>
  );
};

const Logo = styled.img`
  height: 23.3px;
  width: 125.22px;
  path {
    color: red;
  }
`;

export default Image;